import "@/styles/components/cursor.css";
import { isTouchDevice } from "@/scripts/common/util";

let cursorX = 0;
let cursorY = 0;
let targetX = -10;
let targetY = -10;
let prevTargetX = 0;
let prevTargetY = 0;
let currentScaleX = 1;
let currentScaleY = 1;
let targetScaleX = 1;
let targetScaleY = 1;
let easingX = 0.2;
let easingY = 0.2;
let targetOpacity = 1;
let isDragging = false;
let lastTime = 0;
let idleTimeout;

export default {
  init: () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || isTouchDevice) {
      return;
    }

    const cursorContainer = document.createElement("div");
    cursorContainer.id = "app-cursor-container";
    cursorContainer.setAttribute("aria-hidden", "true");
    document.body.appendChild(cursorContainer);

    const cursorCircle = document.createElement("div");
    cursorCircle.id = "app-cursor-circle";
    cursorContainer.appendChild(cursorCircle);

    const cursorContent = document.createElement("span");
    cursorContent.id = "app-cursor-content";
    cursorContainer.appendChild(cursorContent);

    function handleMouseMove(e) {
      const now = performance.now();
      if (now - lastTime < 16) return;

      prevTargetX = targetX;
      prevTargetY = targetY;
      targetX = e.clientX;
      targetY = e.clientY;

      const deltaX = Math.abs(targetX - prevTargetX);
      const deltaY = Math.abs(targetY - prevTargetY);

      if (deltaX > deltaY) {
        easingX = 0.2;
        easingY = 0.3;
      } else {
        easingX = 0.3;
        easingY = 0.2;
      }

      lastTime = now;

      const hoverElement = document.elementFromPoint(targetX, targetY);
      const isHoverable =
        hoverElement &&
        (hoverElement.tagName === "A" ||
          hoverElement.tagName === "BUTTON" ||
          hoverElement.role === "button" ||
          hoverElement.closest("a") ||
          hoverElement.closest("button") ||
          hoverElement.closest("[role=button]"));

      let cursorContentElement = hoverElement?.hasAttribute("data-cursor-content")
        ? hoverElement
        : hoverElement?.closest("[data-cursor-content]");

      if (
        (hoverElement && hoverElement?.hasAttribute("data-cursor-content-ignore")) ||
        (hoverElement && hoverElement.closest("[data-cursor-content-ignore]"))
      ) {
        cursorContentElement = null;
      }

      if (hoverElement && hoverElement.tagName === "A") {
        cursorContentElement = null;
      }

      if (cursorContentElement) {
        const content = cursorContentElement.getAttribute("data-cursor-content");
        cursorContent.innerHTML = content;
        cursorContent.style.display = "block";
        cursorContent.style.opacity = "1";
        targetScaleX = isDragging ? 9 : 8;
        targetScaleY = isDragging ? 9 : 8;
        targetOpacity = 0.8;
      } else {
        cursorContent.style.opacity = "0";
        cursorContent.style.display = "none";
        cursorContent.innerHTML = null;
        targetScaleX = isHoverable ? 3.5 : 1;
        targetScaleY = isHoverable ? 3.5 : 1;
        targetOpacity = isHoverable ? 0.2 : 1;
      }

      if (hoverElement && hoverElement.tagName === "IFRAME") {
        targetScaleX = 0;
        targetScaleY = 0;
      }

      clearTimeout(idleTimeout);

      idleTimeout = setTimeout(() => {
        cursorContent.style.display = "none";
        targetScaleX = 0;
        targetScaleY = 0;
      }, 4000);
    }

    function updateCursor() {
      cursorX += (targetX - cursorX) * 0.2;
      cursorY += (targetY - cursorY) * 0.2;
      currentScaleX += (targetScaleX - currentScaleX) * easingX;
      currentScaleY += (targetScaleY - currentScaleY) * easingY;

      cursorContainer.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0px)`;
      cursorCircle.style.transform = `scale(${currentScaleX}, ${currentScaleY})`;

      document.documentElement.style.setProperty("--cursor-opacity", targetOpacity);

      requestAnimationFrame(updateCursor);
    }

    updateCursor();

    document.addEventListener("mousemove", handleMouseMove);

    document.addEventListener("swiper:drag", (e) => {
      isDragging = true;
      handleMouseMove(e.detail);
    });

    document.addEventListener("swiper:dragend", () => {
      isDragging = false;
    });

    document.addEventListener("mouseleave", () => {
      cursorContent.style.display = "none";
      targetScaleX = 0;
      targetScaleY = 0;
    });

    document.addEventListener("mouseenter", () => {
      targetScaleX = 1;
      targetScaleY = 1;
    });
  },
};
